// ============================================
// HOOK - useRegiones (Regiones y Comunas)
// ============================================

import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '@almacenes/core';

interface Region {
  codigo: number;
  nombre: string;
  ordenGeografico: number;
}

interface Comuna {
  id: number;
  nombre: string;
  region: {
    codigo: number;
    nombre: string;
    ordenGeografico: number;
  };
}

/**
 * Hook para obtener todas las regiones de Chile
 */
export const useRegiones = () => {
  return useQuery({
    queryKey: ['regiones'],
    queryFn: async () => {
      const { data } = await axiosClient.get<Region[]>('/auth/signup/regiones');
      // Ordenar por ordenGeografico
      return data.sort((a, b) => a.ordenGeografico - b.ordenGeografico);
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 horas
    gcTime: 24 * 60 * 60 * 1000,
  });
};

/**
 * Hook para obtener comunas de una región específica
 */
export const useComunas = (codigoRegion: number | null) => {
  return useQuery({
    queryKey: ['comunas', codigoRegion],
    queryFn: async () => {
      if (!codigoRegion) return [];
      const { data } = await axiosClient.get<Comuna[]>(
        `/auth/signup/regiones/${codigoRegion}/comunas`
      );
      // Ordenar alfabéticamente por nombre
      return data.sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    enabled: !!codigoRegion,
    staleTime: 24 * 60 * 60 * 1000, // 24 horas
    gcTime: 24 * 60 * 60 * 1000,
  });
};
